import Alert from '@material-ui/lab/Alert'
import React from 'react'

interface iErrorNotRegisterIen {
  url: string
}

const ErrorNotRegisterIen = ({ url }: iErrorNotRegisterIen) =>
  <Alert severity="warning" style={{ maxWidth: 800 }}>
    Pokud máte zájem elektronicky komunikovat se zadavatelem v rámci této zakázky, založte si nejprve ve zdrojovém
    systému účet tím, že se do něj přihlásíte prostřednictvím vašeho CDD účtu.
    <br/>
    <a href={url + '?auth=1'} target="_blank" rel="noreferrer noopener">
      <strong>Přejít do zdrojového systému</strong>
    </a>
  </Alert>

export default ErrorNotRegisterIen
